import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import { withNamespaces } from 'react-i18next';

class NotificationDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu
    }));
  }

  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="dropdown d-inline-block"
          tag="li"
        >
          <DropdownToggle
            className="btn header-item noti-icon waves-effect"
            tag="button" id="page-header-notifications-dropdown">
            <i className="bx bx-bell"></i>
          </DropdownToggle>

          <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0" right>
            <div className="p-3">
              <Row className="align-items-center">
                <Col>
                  <h6 className="m-0"> {this.props.t('Njoftime')} </h6>
                </Col>
                <div style={{display:'none'}} className="col-auto">
                  <a href="#!" className="small"> Lexo të Gjitha</a>
                </div>
              </Row>
            </div>

            <SimpleBar style={{ height: "250px" }}>
              {(this.props.notifications.length > 0) ?
                this.props.notifications.map((dat, index) => {
                  return (
                    <div key={"headerlink_"+index} onClick={()=>this.props.seeNotification(dat)} className="text-reset notification-item pointer">
                      <div className="media">
                        <div className="media-body">
                          <h6 className="mt-0 mb-1">{dat.title}</h6>
                          <div className="font-size-12 text-muted">
                            <p className="mb-1">{dat.description}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
              :
                <div className="text-center mt-2">
                  <p>
                    Nuk ka njoftime te reja.
                  </p>
                </div>
              }
            </SimpleBar>

            <div style={{display:'none'}}className="p-2 border-top">
              <Link
                className="btn btn-sm btn-link font-size-14 btn-block text-center"
                to="#"
              >
                {" "}
               {this.props.t('View all')}{" "}
              </Link>
            </div>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}
export default withNamespaces()(NotificationDropdown);
